import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { theme, toRem } from 'design';
import { H1, Text } from '../Typography';

const Layout = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: ${toRem(5.5)};
  width: auto;

  @media (min-width: ${theme.breakpoint.large}px) {
    grid-gap: ${toRem(13.75)};
    width: 100%;
  }
`;

const Title = styled(H1).attrs({
  as: 'h3',
})`
  margin-bottom: 0;
  line-height: 100%;
  color: inherit;

  @media (max-width: ${theme.breakpoint.large}px) {
    font-family: ${theme.font.family.euclid};
    font-weight: ${theme.font.weight.semiBold};
    font-size: ${toRem(16.5)};
  }

  span {
    font-weight: ${theme.font.weight.regular};
  }
`;

export const SidebarSubtitle = styled(Text).attrs({
  size: 'small',
})`
  line-height: 100%;
  color: ${theme.color.neutral[800]};
`;

interface SidebarTitleProps {
  children?: ReactNode;
  className?: string;
  subtitle?: string;
  title?: string | ReactNode;
}

export const SidebarTitle = ({ children, className, subtitle, title, ...rest }: SidebarTitleProps) => (
  <Layout className={className} {...rest}>
    {title && <Title>{title}</Title>}
    {subtitle && <SidebarSubtitle>{subtitle}</SidebarSubtitle>}
    {children}
  </Layout>
);
